import { Link } from 'react-router-dom';
import Hero from './components/Hero';
import LocationsSection from './components/LocationsSection';
import Footer from '../../../components/feature/Footer';

export default function SakuraSushiHousePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />

      <div className="max-w-[1400px] mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-zinc-900 mb-4">
            About Sakura Sushi House
          </h2>
          <p className="text-lg text-zinc-600 max-w-3xl mx-auto leading-relaxed">
            Sakura Sushi House brings authentic Japanese cuisine to Juarez with fresh sushi prepared daily and 
            traditional dishes crafted with care. Our chefs are trained in Japanese culinary techniques, ensuring 
            every roll, sashimi plate, and bowl of ramen meets the highest standards of quality and authenticity. 
            We source the freshest ingredients and prepare everything to order for the best possible dining experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="text-center p-8 bg-orange-50 rounded-2xl">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-restaurant-2-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-zinc-900 mb-2">Fresh Sushi Daily</h3>
            <p className="text-zinc-600">Expertly crafted sushi rolls with the freshest ingredients</p>
          </div>

          <div className="text-center p-8 bg-orange-50 rounded-2xl">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-bowl-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-zinc-900 mb-2">Authentic Ramen</h3>
            <p className="text-zinc-600">Traditional Japanese ramen with rich, flavorful broth</p>
          </div>

          <div className="text-center p-8 bg-orange-50 rounded-2xl">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-leaf-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-zinc-900 mb-2">Vegetarian Options</h3>
            <p className="text-zinc-600">Extensive menu of vegetarian and vegan-friendly dishes</p>
          </div>
        </div>

        {/* Locations */}
        <LocationsSection />
      </div>

      <section className="bg-gradient-to-br from-orange-500 to-orange-600 py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">
            Visit Sakura Sushi House Today
          </h2>
          <p className="text-white/90 text-lg mb-8">
            Experience fresh sushi and authentic Japanese cuisine
          </p>
          <Link
            to="/places-to-eat"
            className="inline-flex items-center gap-2 bg-white text-orange-600 px-8 py-4 rounded-full font-semibold hover:bg-orange-50 transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-left-line text-xl"></i>
            Back to All Restaurants
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
